<ng-container *ngIf="template == 'theme1'">    
    <div class="form-checkbox">
        <div class="checkbox-click" [ngClass]="{'active' : value}">
            <input class="input" type="checkbox" [formControlName]="controlName">
        </div>
        <div class="label" ng-click="model = !model">
            <body-text [textContent]="placeHolder"></body-text>
        </div>
    </div>
</ng-container>